import { render, staticRenderFns } from "./AcceleratorReview.vue?vue&type=template&id=019614d7&"
import script from "./AcceleratorReview.vue?vue&type=script&lang=js&"
export * from "./AcceleratorReview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports